import { validateFormat } from 'ember-changeset-validations/validators';
import { customMessageValidator } from 'uplisting-frontend/validators/custom-message';

export const ExternalIcalValidation = {
  url: customMessageValidator(
    'external_ical_url',
    validateFormat({
      type: 'url',
    }),
  ),
};
